import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";
import { useIsMobile } from "@/hooks/useResponsive";

const ROW_COUNT = 10;
const CARD_COUNT = 6;

export const RepTop30Skeleton = () => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <div aria-label="Loading rep top 30" style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {Array.from({ length: CARD_COUNT }).map((_, i) => (
          <Box key={i} sx={{ p: 1.5, border: "1px solid var(--divider-main)", borderRadius: "var(--border-radius-main)" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
              <Skeleton variant="circular" width={40} height={40} />
              <Box sx={{ flex: 1 }}>
                <Skeleton variant="text" width="50%" height={22} />
                <Skeleton variant="text" width="70%" height={16} />
              </Box>
            </Box>
            <Skeleton variant="rounded" width={110} height={28} />
          </Box>
        ))}
      </div>
    );
  }

  return (
    <table aria-label="Loading rep top 30">
      <colgroup>
        <col width="4%" />
        <col width="22%" />
        <col width="26%" />
        <col width="14%" />
        <col width="14%" />
        <col width="20%" />
      </colgroup>
      <thead>
        <tr>
          <th>#</th>
          <th>Person</th>
          <th>Relationship Level</th>
          <th>Role</th>
          <th>Market</th>
          <th>Country</th>
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: ROW_COUNT }).map((_, i) => (
          <tr key={i}>
            <td><Skeleton variant="text" width={20} /></td>
            <td>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <Skeleton variant="circular" width={32} height={32} />
                <Skeleton variant="text" width="60%" />
              </div>
            </td>
            <td><Skeleton variant="rounded" width={100} height={28} /></td>
            <td><Skeleton variant="text" width="70%" /></td>
            <td><Skeleton variant="text" width="60%" /></td>
            <td><Skeleton variant="text" width="50%" /></td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
